import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import CaseStudy from "@/pages/CaseStudy";
import AdminLeads from "@/pages/AdminLeads";
import LegalNotice from "@/pages/LegalNotice";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { ScrollProgress } from "@/components/ScrollProgress";
import { CursorGlow } from "@/components/CursorGlow";

function App() {
  return (
    <LanguageProvider>
    <div className="App">
      <div className="grain-overlay" />
      <ScrollProgress />
      <CursorGlow />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0B1622",
            border: "1px solid rgba(212,175,55,0.4)",
            color: "#fff",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projet/:slug" element={<CaseStudy />} />
          <Route path="/admin" element={<AdminLeads />} />
          <Route path="/prive" element={<AdminLeads />} />
          <Route path="/mentions-legales" element={<LegalNotice />} />
        </Routes>
      </BrowserRouter>
    </div>
    </LanguageProvider>
  );
}

export default App;
